import {createContext} from 'react';

export const GroupsContext = createContext();
